import type { CompanyAnalytics } from "@/modules/companies/client/api/types"
import type {
  TopContracts,
  TopMonths,
  TopPositions,
} from "@/modules/companies/client/components/RecruitmentPatternInformation/utils/analyticsUtils"

import {
  getHasEnoughData,
  getThreeTopMonths,
  getTopContracts,
  getTopPositions,
} from "@/modules/companies/client/components/RecruitmentPatternInformation/utils/analyticsUtils"
import { useCompanyAnalyticsFetch } from "@/modules/companies/client/hooks/useCompanyAnalyticsFetch"

export type UseCompanyAnalyticsData = {
  hasEnoughData: boolean
  topPositions: TopPositions
  topContract: TopContracts
  topMonths: TopMonths
}

export const useCompanyAnalyticsData = (): UseCompanyAnalyticsData => {
  const { dataCompanyAnalytics } = useCompanyAnalyticsFetch()
  const hasEnoughData = getHasEnoughData(dataCompanyAnalytics)

  return {
    hasEnoughData,
    topContract: hasEnoughData ? getTopContracts(dataCompanyAnalytics as CompanyAnalytics) : null,
    topMonths: hasEnoughData ? getThreeTopMonths(dataCompanyAnalytics as CompanyAnalytics) : null,
    topPositions: hasEnoughData ? getTopPositions(dataCompanyAnalytics as CompanyAnalytics) : null,
  }
}
